module.exports = __webpack_public_path__ + "19_tvcg_1.jpg?7228a470b6025f50255c5359f778db06";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_tvcg_1.jpg
// module id = 169
// module chunks = 0